module.exports = __webpack_public_path__ + "img/logo2-fr.bea3cea6.png";